/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Preview_PendingInputs */

const en_platform_preview_pending = /** @type {(inputs: Platform_Preview_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for your yes`)
};

const pl_platform_preview_pending = /** @type {(inputs: Platform_Preview_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czeka na Twoje „tak”`)
};

/**
* | output |
* | --- |
* | "Waiting for your yes" |
*
* @param {Platform_Preview_PendingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_preview_pending = /** @type {((inputs?: Platform_Preview_PendingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Preview_PendingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_preview_pending(inputs)
	return en_platform_preview_pending(inputs)
});